var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sop_route_box" },
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            { attrs: { model: _vm.queryForm, size: "mini" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.module"),
                            prop: "moduleId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.moduleId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "moduleId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.moduleId",
                              },
                            },
                            _vm._l(_vm.moduleList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("navbar.menu"),
                            prop: "menuId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "collectionCenter.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.menuId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "menuId", $$v)
                                },
                                expression: "queryForm.params.menuId",
                              },
                            },
                            _vm._l(_vm.menuList, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("trajectory.state"),
                            prop: "status",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("collectionCenter.tudo"),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "status", $$v)
                                },
                                expression: "queryForm.params.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.enable"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.disable"),
                                  value: 0,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("userManage.creator"),
                            prop: "createUser",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.Only10AreDisplayed"
                                ),
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getUserList,
                              },
                              on: {
                                clear: function ($event) {
                                  return _vm.getUserList()
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.createUser,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "createUser",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.createUser",
                              },
                            },
                            _vm._l(_vm.userList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.realName +
                                    "（" +
                                    item.createUserName +
                                    "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-search",
                    size: "small",
                    type: "primary",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.search()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("newOrder.search")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh-right", size: "small" },
                  on: { click: _vm.reset },
                },
                [_vm._v(_vm._s(_vm.$t("newOrder.reset")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-bottom": "10px" },
              attrs: { size: "mini", icon: "el-icon-plus", type: "primary" },
              on: { click: _vm.addClick },
            },
            [_vm._v(_vm._s(_vm.$t("collectionCenter.add")))]
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "border-radius": "0 !important" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.ind"),
                  type: "index",
                  width: "60",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("navbar.sopNumber"),
                  prop: "sopNo",
                  align: "center",
                  width: "230",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "text_class deepblue",
                            on: {
                              click: function ($event) {
                                return _vm.viewRow(scope.row)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.sopNo) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.module"),
                  prop: "moduleName",
                  align: "center",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("navbar.menu"),
                  prop: "menuName",
                  align: "center",
                  width: "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("trajectory.state"),
                  prop: "status",
                  align: "center",
                  width: "90",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status !== ""
                          ? _c("div", [
                              scope.row.status === 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("GlobalSetObj.enable"))
                                    ),
                                  ])
                                : _vm._e(),
                              scope.row.status === 0
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("GlobalSetObj.disable"))
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _c("span", [_vm._v(" - - ")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("navbar.totalPreviewCount"),
                  prop: "totalPreviewCount",
                  align: "center",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "text_class blue",
                            on: {
                              click: function ($event) {
                                _vm.totalCount(
                                  scope.row,
                                  _vm.$t("navbar.totalPreviewCount"),
                                  1
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.totalPreviewCount))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("navbar.totalDownloadCount"),
                  prop: "totalDownloadCount",
                  align: "center",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "text_class blue",
                            on: {
                              click: function ($event) {
                                _vm.totalCount(
                                  scope.row,
                                  _vm.$t("navbar.totalDownloadCount"),
                                  1
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.totalDownloadCount))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("userManage.creator"),
                  prop: "createUserName",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Resource.CreationTime"),
                  prop: "createTime",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("userManage.ModifyThePerson"),
                  prop: "updateUserName",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("userManage.ModificationTime"),
                  prop: "updateTime",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  align: "center",
                  width: "260",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "small",
                              round: "",
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.editRow(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("CenterForSorting.modify")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "small",
                              round: "",
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.downloadClick(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("navbar.downloadFile")))]
                        ),
                        scope.row.status === 1 || scope.row.status === 0
                          ? _c(
                              "span",
                              [
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: {
                                      title:
                                        scope.row.status === 1
                                          ? _vm.$t(
                                              "basicData.AreYouSureDisabled"
                                            )
                                          : _vm.$t(
                                              "basicData.AreYouSureEnabled"
                                            ),
                                    },
                                    on: {
                                      confirm: function ($event) {
                                        return _vm.changeState(
                                          scope.row,
                                          scope.row.status
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        class:
                                          scope.row.status === 1
                                            ? "gold_bg"
                                            : "green_bg",
                                        staticStyle: { "margin-left": "10px" },
                                        attrs: {
                                          slot: "reference",
                                          size: "small",
                                          round: "",
                                        },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.status === 1
                                              ? _vm.$t("basicData.disable")
                                              : _vm.$t("basicData.enable")
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100, 500, 1000],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": function ($event) {
                    return _vm.search()
                  },
                  "size-change": function ($event) {
                    return _vm.search(1)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("addEdit", {
        ref: "aeRef",
        attrs: {
          "module-list": _vm.moduleList,
          "menu-list": _vm.menuList,
          "permission-list": _vm.permissionList,
        },
        on: {
          search: function ($event) {
            return _vm.search()
          },
        },
      }),
      _c("dialogChild", { ref: "dialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }